import RGB from './RGB';

export default class SpecularRGB extends RGB {
	lobe: number;

	constructor (r: number, g: number, b: number, lobe: number) {
		super(r, g, b);
		this.lobe = lobe;
	}

	copy () {
		return new SpecularRGB(this.r, this.g, this.b, this.lobe);
	}
}
